React = require 'react'
t = require('views/internal/recup-with-helpers')('reactions')

module.exports = class ReactionIcon extends React.Component
  displayName: 'ReactionIcon'
  render: t.renderable ->
    { disabled, icon, withBorder, active, onClick } = @props
    iconUrl = require('images/reactions/add-reaction@2x.png')
    disabledIconUrl = require('images/reactions/add-reaction-disabled@2x.png')
    activeIconUrl = require('images/reactions/add-reaction-active@2x.png')

    t.span
      class: t.classify('reactions-add': true, 'disabled': disabled, 'reactions-add-with-border': withBorder, 'active': active)
      onClick: onClick
    , ->
      # icon without border is handled by bg images via css
      if withBorder
        t.img '.reactions-add-img',
          alt: t.l 'add-reaction'
          src: if disabled then disabledIconUrl else iconUrl
          title: t.l 'add-reaction'
        t.img '.reactions-add-active-img',
          alt: t.l 'add-reaction'
          src: activeIconUrl
          title: t.l 'add-reaction'



// WEBPACK FOOTER //
// ./app/scripts/views/reactions/reaction-icon.coffee